import { useGetExpiredLeadsQuery, LEADS_PAGE_SIZE } from '@/services/leads';
import { Box, Card, Icon, Pagination } from '@palmetto/palmetto-components';
import { useMemo } from 'react';

import { LeadManagementFilter } from './LeadManagementFilter';
import { LeadManagementLoading } from './LeadManagementLoading';
import { LeadManagementTable } from './LeadManagementTable';
import { useLeadTabParams } from './useLeadTabParams';

const primaryColorStyle: React.CSSProperties = { color: 'var(--btn-bg-primary-idle)' };
const prevPageIcon = <Icon name="caret-left" size="sm" style={primaryColorStyle} />;
const nextPageIcon = <Icon name="caret-right" size="sm" style={primaryColorStyle} />;

export function LeadManagementExpiredTab() {
  const {
    queryArgs,
    page,
    searchTerm,
    appliedSort,
    activeFilterCount,
    currentFilters,
    handleSortSelection,
    handlePageChange,
    handleSearchChange,
    handleApplyFilters,
  } = useLeadTabParams();
  const { data, isLoading } = useGetExpiredLeadsQuery(queryArgs);
  const leads = useMemo(() => data?.leads ?? [], [data?.leads]);

  return (
    <Card padding="xs" marginTop="0">
      <Card.Header>
        <Box direction="row" justifyContent="space-between" alignItems="center">
          <Box fontSize="xl" fontWeight="medium">
            Expired
          </Box>
        </Box>
      </Card.Header>
      <Box margin="0 lg lg lg" direction="column" childGap="md">
        <LeadManagementFilter
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          activeFilterCount={activeFilterCount}
          currentFilters={currentFilters}
          onApplyFilters={handleApplyFilters}
          appliedSort={appliedSort}
          onSortChange={handleSortSelection}
        />
        <Box overflow="hidden" radius="md">
          {isLoading ? (
            <Box padding="md">
              <LeadManagementLoading />
            </Box>
          ) : (
            <LeadManagementTable leads={leads} statusDateLabel="Date Expired" />
          )}
        </Box>
        {(data?.total ?? 0) > LEADS_PAGE_SIZE && (
          <Pagination
            activePage={page}
            arePagesVisible
            itemsPerPage={LEADS_PAGE_SIZE}
            numberOfPagesDisplayed={3}
            onChange={handlePageChange}
            totalItemsCount={data?.total ?? 0}
            isCompact
            prevPageText={prevPageIcon}
            nextPageText={nextPageIcon}
          />
        )}
      </Box>
    </Card>
  );
}
